module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "cell-section"
  }, [_c('div', {
    staticClass: "cell-header"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.cellHeader) + "\n\t\t")]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69a4f5f1"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/baseComponents/MyCellHeader.vue
// module id = 1066
// module chunks = 1